// Client access to the live external liquidity pools for 01.
//
// The api-server reads these from a public market-data source, normalises the
// fields, and computes an estimated fee APR (see routes/pools.ts). We just
// fetch and refresh them. The shape mirrors the server's PoolEntry.
import { useQuery } from "@tanstack/react-query";
import { apiBase } from "@/lib/api-base";

export interface PoolEntry {
  id: string;
  name: string;
  platform: string;
  feePct: number | null;
  tvlUsd: number | null;
  volume24hUsd: number | null;
  priceUsd: number | null;
  fdvUsd: number | null;
  aprPct: number | null;
  priceChange24hPct: number | null;
  txns24h: number | null;
  createdAt: string | null;
  isMain: boolean;
  addLiquidityUrl: string;
  explorerUrl: string;
}

export interface PoolsPayload {
  pools: PoolEntry[];
  /** Canonical market price for 01 (deepest qualifying pool), or null. */
  marketPriceUsd: number | null;
  /** Name of the pool the market price was taken from, or null. */
  marketPoolName: string | null;
  updatedAt: number;
}

async function fetchPools(): Promise<PoolsPayload> {
  const res = await fetch(`${apiBase()}/pools`);
  if (!res.ok) throw new Error("could not load liquidity pools");
  return (await res.json()) as PoolsPayload;
}

export function usePools() {
  return useQuery({
    queryKey: ["pools"],
    queryFn: fetchPools,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
